<template>
  <component :is="layout">
    <router-view></router-view>
  </component>
</template>

<script>
import { defineComponent } from 'vue';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import AppLayout from '@/app/layout/app-layout';
import ShowcaseLayout from '@/showcase/layout/showcase-layout.vue';
import { getStorage, socket, apiHttpClient } from './app.service';

export default defineComponent({
  async created() {
    // 用户令牌
    const accessToken = getStorage('nid');
    const refreshToken = getStorage('rid');

    if (accessToken && refreshToken) {
      this.setToken({ accessToken, refreshToken });
      await this.configApiHttpClientAuthHeader(accessToken);
    }

    // 当前用户
    const userId = getStorage('uid');

    if (userId) {
      try {
        await this.getCurrentUser(userId);
      } catch (error) {
        if (error.status === 403) {
          await this.logout();
          this.$router.push({ name: 'showcaseHome' });
        }
      }
    }

    // 设置请求头部
    socket.on('connect', () => {
      apiHttpClient.defaults.headers.common['X-Socket-Id'] = socket.id;
      this.setSocketId(socket.id);
    });
  },

  methods: {
    ...mapMutations({
      setToken: 'auth/setToken',
      setSocketId: 'user/setSocketId',
    }),

    ...mapActions({
      configApiHttpClientAuthHeader: 'auth/configApiHttpClientAuthHeader',
      getCurrentUser: 'user/getCurrentUser',
      logout: 'auth/logout',
    }),
  },

  computed: {
    ...mapGetters({
      layout: 'layout/layout',
    }),
  },

  components: {
    AppLayout,
    ShowcaseLayout,
  },
});
</script>

<style>
@import './styles/normalize.css';
@import './styles/base.css';
@import './styles/theme.css';
@import './styles/app.css';
@import './styles/page.css';
@import './styles/form.css';
@import './styles/button.css';
@import './styles/font.css';
</style>
